import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import PreventivoModal from "../components/PreventivoModal";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://interventi.synology.me:5050";

const Preventivi = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPreventivo, setSelectedPreventivo] = useState(null);
  const [modalMode, setModalMode] = useState("create");
  const [preventivi, setPreventivi] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  useEffect(() => {
    console.log("Componente Preventivi montato, isModalOpen:", isModalOpen);
    fetchPreventivi();
  }, []);

  const fetchPreventivi = async () => {
    console.log("📄 Inizio fetchPreventivi");
    setIsLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/preventivi`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        withCredentials: true,
      });
      setPreventivi(response.data);
      console.log("📄 fetchPreventivi completato:", response.data);
    } catch (error) {
      console.error("❌ Errore durante il recupero dei preventivi:", error.response ? error.response.data : error.message);
      toast.error("Errore nel caricamento dei preventivi!");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModal = async (mode, preventivo = null) => {
    console.log("Apertura modal in modalità:", mode);
    setModalMode(mode);
    setIsModalOpen(false);

    if (mode === "edit" && preventivo?.id) {
      setIsLoadingModal(true);
      try {
        const res = await axios.get(`${API_BASE_URL}/preventivi/${preventivo.id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          withCredentials: true,
        });

        const preventivoCompleto = res.data;
        console.log("📄 Preventivo completo ricevuto:", preventivoCompleto);
        setSelectedPreventivo(preventivoCompleto);
      } catch (error) {
        console.error("❌ Errore nel recupero del preventivo completo:", error.response?.data || error.message);
        toast.error(error.response?.data?.message || "Errore nel recupero del preventivo");
        return;
      } finally {
        setIsLoadingModal(false);
      }
    } else {
      setSelectedPreventivo(null);
    }

    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    console.log("Chiusura modal");
    setIsModalOpen(false);
    setSelectedPreventivo(null);
    fetchPreventivi();
  };

  const handleDeletePreventivo = async (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questo preventivo?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/preventivi/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        withCredentials: true,
      });
      toast.success("Preventivo eliminato!");
      fetchPreventivi();
    } catch (error) {
      console.error("❌ Errore durante l'eliminazione del preventivo:", error.response?.data || error.message);
      toast.error("Errore durante l'eliminazione del preventivo!");
    }
  };

  const handleDownloadPDF = (id) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/preventivi/${id}?format=pdf&token=${token}`;
  window.open(url, "_blank");
};


  return (
    <div>
      <h3 className="interventi-title">Preventivi</h3>
      <button
        onClick={() => handleOpenModal("create")}
        className="add-btn"
        style={{ marginBottom: "20px", backgroundColor: "#1e8449", color: "white", padding: "10px 20px" }}
      >
        <FaPlus /> Nuovo Preventivo
      </button>
      {isLoading ? (
        <p>Caricamento...</p>
      ) : preventivi.length === 0 ? (
        <p>Nessun preventivo disponibile</p>
      ) : (
        <table className="interventi-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Indirizzo</th>
              <th>Data Emissione</th>
              <th>Descrizione</th>
              <th>Iva</th>
              <th>Stato</th>
              <th>Dettagli</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {preventivi.map((preventivo) => (
              <tr key={preventivo.id}>
                <td>{preventivo.id}</td>
                <td>{preventivo.cliente || "/"}</td>
                <td>{preventivo.indirizzo || "/"}</td>
                <td>{preventivo.dataEmissione ? new Date(preventivo.dataEmissione).toLocaleDateString() : "/"}</td>
                <td>{preventivo.descrizione || "Senza descrizione"}</td>
                <td>
                  {typeof preventivo.costoTotaleConIva === "number" && !isNaN(preventivo.costoTotaleConIva)
                    ? preventivo.costoTotaleConIva.toFixed(2)
                    : "N/D"}
                </td>
                <td>{preventivo.stato || "Da fare"}</td>
                <td>
                  <Link to={`/preventivi/${preventivo.id}`} className="view-btn">
                    <FaEye /> Visualizza
                  </Link>
                </td>
                <td className="flex">
                  <button onClick={() => handleDownloadPDF(preventivo.id)} className="pdf-btn">
                    <FaEye /> PDF
                  </button>
                  <button onClick={() => handleOpenModal("edit", preventivo)} className="edit-btn">
                    <FaEdit /> Modifica
                  </button>
                  <button onClick={() => handleDeletePreventivo(preventivo.id)} className="delete-btn">
                    <FaTrash /> Cancella
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <PreventivoModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={fetchPreventivi}
        selectedPreventivo={selectedPreventivo}
        modalMode={modalMode}
        handleDownloadPDF={handleDownloadPDF}
        isLoading={isLoadingModal}
      />
    </div>
  );
};

export default Preventivi;